/* eslint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config file > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/



import {Dialog,LoadingBar,Meta,Notify} from 'quasar'



export default { config: {"dark":true,"loadingBar":{"color":"primary","position":"bottom","size":"6px"},"notify":{"color":"primary","position":"center","progress":true,"textColor":"dark","timeout":2000}},plugins: {Dialog,LoadingBar,Meta,Notify} }

